import { render, staticRenderFns } from "./ProductDetailsCard.vue?vue&type=template&id=0614551d&scoped=true"
import script from "./ProductDetailsCard.vue?vue&type=script&lang=js"
export * from "./ProductDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailsCard.vue?vue&type=style&index=0&id=0614551d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0614551d",
  null
  
)

export default component.exports